"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.exist = exports.aggMatchesFromPropsList = exports.aggKeysFromPropsList = exports.getOuttermostProperty = exports.getInnermostProperty = void 0;
var REQUEST_META = ['header', 'query'];
exports.getInnermostProperty = function getInnermostProperty(propsList, propName) {
    for (var i = propsList.length - 1; i >= 0; i--) {
        var props = propsList[i];
        if (props.hasOwnProperty(propName)) {
            return props[propName];
        }
    }
    return null;
};
exports.getOuttermostProperty = function getOuttermostProperty(propsList, propName) {
    for (var _i = 0, propsList_1 = propsList; _i < propsList_1.length; _i++) {
        var props = propsList_1[_i];
        if (props.hasOwnProperty(propName)) {
            return props[propName];
        }
    }
    return null;
};
exports.aggKeysFromPropsList = function aggKeysFromPropsList(propsList, propName) {
    var initResult = REQUEST_META.reduce(function (result, next) {
        var key = next;
        result[key] = [];
        return result;
    }, {});
    var res = propsList
        .filter(function (props) {
        return usefulObject(props[propName]);
    })
        .reduce(function (result, next) {
        REQUEST_META.forEach(function (key) {
            var prop = next[propName];
            if (prop && prop.hasOwnProperty(key) && usefulArray(prop[key])) {
                result[key] = unique(result[key].concat(prop[key]));
            }
        });
        return result;
    }, initResult);
    return REQUEST_META.reduce(function (result, next) {
        var _a;
        var key = next;
        if (result[key] && ((_a = result[key]) === null || _a === void 0 ? void 0 : _a.length) === 0) {
            delete result[key];
        }
        return result;
    }, res);
};
exports.aggMatchesFromPropsList = function aggMatchesFromPropsList(propsList, propName) {
    var initResult = REQUEST_META.reduce(function (result, next) {
        var key = next;
        result[key] = {};
        return result;
    }, {});
    var res = propsList
        .filter(function (props) {
        return usefulObject(props[propName]);
    })
        .reduce(function (result, next) {
        REQUEST_META.forEach(function (key) {
            var prop = next[propName];
            // 这边目前是浅拷贝，越后渲染优先级越高
            if (prop && prop.hasOwnProperty(key) && usefulObject(prop[key])) {
                result[key] = Object.assign(result[key], prop[key]);
            }
        });
        return result;
    }, initResult);
    return REQUEST_META.reduce(function (result, next) {
        var key = next;
        if (result[key] && Object.keys(result[key]).length === 0) {
            delete result[key];
        }
        return result;
    }, res);
};
function unique(arr) {
    return Array.from(new Set(arr));
}
function usefulObject(target) {
    if (!exist(target)) {
        return false;
    }
    return target.constructor === Object && Object.keys(target).length > 0;
}
function usefulArray(target) {
    if (!exist(target)) {
        return false;
    }
    return Array.isArray(target) && target.length > 0;
}
function exist(target) {
    return target != null;
}
exports.exist = exist;
